import React from 'react'

function Footer() {
  return (
    <Footer>
        <p> © 2024 Cristian Camilo Medina Sánchez. Todos los derechos reservados. El código fuente y los contenidos de este software están protegidos por las leyes de propiedad intelectual y derechos de autor. El uso de imágenes y el diseño de menú están inspirados en el concepto de restaurantes de comida rápida, específicamente en el modelo de McDonald's, pero este software no tiene ninguna relación oficial ni pretende infringir los derechos de la marca McDonald's. Queda estrictamente prohibida la reproducción, distribución, modificación, o uso no autorizado de este material sin el consentimiento expreso del titular. El incumplimiento de estas condiciones puede dar lugar a acciones legales</p>
        
    </Footer>
  )
}

export default Footer